module.exports = __webpack_public_path__ + "img/1.40f5c048.jpg";